import aiBillingApi from '@app/api/aiBilling';
import lqaSuggestionsApi from '@app/api/lqaSuggestions';
import statisticsApi from '@app/api/statistics';
import commentsMiddleware from '@app/features/comments/store/middleware';

import aiApi from './ai';
import appsApi from './apps';
import authBase from './authBase';
import branchApi from './branch';
import collaborationApi from './collaboration';
import contributorsApi from './contributors';
import countryApi from './country';
import currentUserApi from './currentUser';
import editorApi from './editor';
import emailConfirmationApi from './emailConfirmation';
import environmentApi from './environment';
import glossaryApi from './glossary';
import keyApi from './key';
import languagesApi from './languages';
import newProjectApi from './newProject';
import preferencesApi from './preferences';
import profileApi from './profile';
import projectApi from './project';
import projectFilesApi from './projectFiles';
import projectLanguagesApi from './projectLanguages';
import projectSetupApi from './projectSetup';
import projectsApi from './projects';
import quickStartApi from './quickStart';
import reviewCenterApi from './reviewCenter';
import settingsApi from './settings';
import shortcutsApi from './shortcuts';
import styleGuideApi from './styleGuide';
import tasksApi from './tasks';
import teamDomainApi from './teamDomain';
import translationApi from './translation';
import translationMemoryApi from './translationMemory';
import uploadHandlerApi from './uploadHandler';
import userApi from './user';
import userPreferencesApi from './userPreferences';
import viewerApi from './viewer';

export default [
    appsApi.middleware,
    branchApi.middleware,
    contributorsApi.middleware,
    countryApi.middleware,
    collaborationApi.middleware,
    currentUserApi.middleware,
    editorApi.middleware,
    emailConfirmationApi.middleware,
    environmentApi.middleware,
    glossaryApi.middleware,
    languagesApi.middleware,
    newProjectApi.middleware,
    preferencesApi.middleware,
    profileApi.middleware,
    projectApi.middleware,
    projectLanguagesApi.middleware,
    projectsApi.middleware,
    quickStartApi.middleware,
    settingsApi.middleware,
    keyApi.middleware,
    shortcutsApi.middleware,
    tasksApi.middleware,
    teamDomainApi.middleware,
    translationApi.middleware,
    translationMemoryApi.middleware,
    uploadHandlerApi.middleware,
    userApi.middleware,
    userPreferencesApi.middleware,
    projectSetupApi.middleware,
    authBase.middleware,
    statisticsApi.middleware,
    commentsMiddleware.middleware,
    viewerApi.middleware,
    aiApi.middleware,
    aiBillingApi.middleware,
    reviewCenterApi.middleware,
    projectFilesApi.middleware,
    styleGuideApi.middleware,
    lqaSuggestionsApi.middleware,
];
